module.exports = __webpack_public_path__ + "img/toronto1.9e23be08.png";